<template>
  <el-table
    :data="data"
    :row-style="{ backgroundColor: '#ebeef5' }"
    :header-row-style="{ backgroundColor: '#ebeef5' }"
    :header-cell-style="{ backgroundColor: '#ebeef5' }"
    :row-class-name="getRowClasses"
    :row-key="row_key"
    :expand-row-keys="expandRowKeys"
    @expand-change="handleExpandChange"
  >
    <el-table-column type="expand">
      <template slot-scope="scope">
        <massive-reserve-from-one-server-list
          v-if="scope.row.transfers.length > 1"
          :data="scope.row.transfers"
          :server-id="serverId"
          :go-to-server-page="goToServerPage"
          :go-to-report-in-admin-lk="goToReportInAdminLk"
          :is-return-button-loading="isReturnButtonLoading"
          :handle-return-cameras-button="handleReturnCamerasButton"
        />
      </template>
    </el-table-column>
    <el-table-column label="Сервер" prop="server_from-name">
      <template slot-scope="scope">
        <el-tooltip
          v-if="serverId == null || scope.row.server_from.id !== serverId"
          content="Перейти в страницу сервера"
          :open-delay="1000"
        >
          <el-link
            type="primary"
            @click="goToServerPage(scope.row.server_from.id, scope.row.server_from.id_operator)"
            class="link"
          >
            {{ scope.row.server_from.name || 'Нет данных' }}
          </el-link>
        </el-tooltip>
        <template v-else>
          {{ scope.row.server_from.name || 'Нет данных' }}
        </template>
      </template>
    </el-table-column>
    <el-table-column label="Резервный сервер" prop="server_to-name">
      <template slot-scope="scope">
        <el-tooltip
          v-if="serverId == null || scope.row.transfers[0].server_to.id !== serverId"
          content="Перейти в страницу сервера"
          :open-delay="1000"
        >
          <el-link
            type="primary"
            @click="goToServerPage(scope.row.transfers[0].server_to.id, scope.row.transfers[0].server_to.id_operator)"
            class="link"
          >
            {{ scope.row.transfers[0].server_to.name || 'Нет данных' }}
          </el-link>
        </el-tooltip>
        <template v-else>
          {{ scope.row.transfers[0].server_to.name || 'Нет данных' }}
        </template>
      </template>
    </el-table-column>
    <el-table-column label="Статус" prop="status_description">
      <template slot-scope="scope">
        <el-tooltip
          v-if="scope.row.transfers[0].is_report_accessible === 1"
          content="Перейти в ЛК администратора"
          :open-delay="1000"
        >
          <el-link
            type="primary"
            class="link"
            @click="goToReportInAdminLk(scope.row.transfers[0].id_reserve_transfer)"
          >
            {{ scope.row.transfers[0].status_description }}
          </el-link>
        </el-tooltip>
        <template v-else>
          {{ scope.row.transfers[0].status_description }}
        </template>
      </template>
    </el-table-column>
    <el-table-column label="Дата/время" prop="start_dt">
      <template slot-scope="scope">
        <span>{{ scope.row.transfers[0].start_dt }}</span>
      </template>
    </el-table-column>
    <el-table-column>
      <template slot-scope="scope">
        <el-button
          v-if="scope.row.status !== 11"
          class="return_button"
          size="small"
          type="primary"
          :loading="isReturnButtonLoading"
          @click="() => handleReturnCamerasButton(scope.row.transfers[0])"
        >
          Вернуть камеры на свой сервер
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import MassiveReserveFromOneServerList from './MassiveReserveFromOneServerList'

export default {
  name: "MassiveReserveTransferList",
  components: { MassiveReserveFromOneServerList },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    serverId: {
      type: Number,
      default: 0,
    },
    goToServerPage: {
      type: Function,
      default: () => {},
    },
    goToReportInAdminLk: {
      type: Function,
      default: () => {},
    },
    isReturnButtonLoading: {
      type: Boolean,
      default: false,
    },
    handleReturnCamerasButton: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      expandRowKeys: []
    }
  },
  methods: {
    getRowClasses ({ row }) {
      return row.transfers.length === 1 ? 'no-expand' : null
    },
    row_key(row) {
      return row.id
    },
    handleExpandChange(row) {
      const id = row.id
      const indexExpandedRow = this.expandRowKeys.findIndex((idExpanded) => id === idExpanded)
      if (indexExpandedRow !== -1) {
        this.expandRowKeys.splice(indexExpandedRow, 1)
      } else {
        this.expandRowKeys.push(id)
      }
    }
  },
};
</script>

<style>
</style>
